angular.module('angus.directives').directive('copyLayout', [
    'actionViewTemplates',
    function(actionViewTemplates) {
        return {
            scope: {
                settings: "=",
            },
            restrict: 'E',
            templateUrl: actionViewTemplates.copyLayout
        }
    }
]);